<template>
  <section
    :class="_class"
    v-bind="$attrs"
  >
    <!-- @slot Container 内容 -->
    <slot />
  </section>
</template>

<script>
const name = 'ten-container';
export default {
  name,
  props: {
    /**
     * 容器内子元素排列方向【注意：若无设置，则根据子无素中是否含有 `ten-header` 或 `ten-footer` 来确认排列方向，有则等同于 vertical，无则等同于 horizontal。】
     * @member vertical | horizontal
     */
    direction: String,
  },
  computed: {
    _isVertical() {
      if (this.direction === 'vertical') return true;
      if (this.direction === 'horizontal') return false;
      if (this.$slots && this.$slots.default) {
        return this.$slots.default.some((vnode) => {
          const vnodeTag = vnode.componentOptions && vnode.componentOptions.tag;
          return vnodeTag === 'ten-header' || vnodeTag === 'ten-footer';
        });
      }
      return false;
    },
    _class() {
      return [
        name,
        {
          [`${name}--vertical`]: this._isVertical,
        },
      ];
    },
  },
};
</script>
